// extracted by mini-css-extract-plugin
export default {"chevron":"rotatable-chevron_chevron__pDprW","open":"rotatable-chevron_open__4kk2V"};